import { render } from "./BNavbar.vue?vue&type=template&id=25608a27"
import script from "./BNavbar.vue?vue&type=script&lang=js"
export * from "./BNavbar.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__